import gsap from 'gsap'
import { CustomEase } from "gsap/CustomEase";
import * as $ from 'jquery';
import { start } from 'bodymovin';
import lottie from "lottie-web";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import LocomotiveScroll from 'locomotive-scroll';
import barba from '@barba/core';

gsap.registerPlugin(ScrollTrigger);

export function scrollthankyou(locoScroll) {

$(document).ready(function() {
        
        locoScroll.on("scroll", ScrollTrigger.update);
        if(this.timelinegsap){
            this.timelinegsap.kill()
        }
        this.timelinegsap = gsap.timeline()
        ScrollTrigger.removeEventListener()
        ScrollTrigger.refresh()
        ScrollTrigger.scrollerProxy(".smooth-scroll", {
            scrollTop(value) {
              return arguments.length ? locoScroll.scrollTo(value, 0, 0) :    locoScroll.scroll.instance.scroll.y;
            }, // we don't have to define a scrollLeft because we're only scrolling vertically.
            getBoundingClientRect() {
                return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight};
            },
            // LocomotiveScroll handles things completely differently on mobile devices - it doesn't even transform the container at all! So to get the correct behavior and avoid jitters, we should pin things with position: fixed on mobile. We sense it by checking to see if there's a transform applied to the container (the LocomotiveScroll-controlled element).
            // pinType: document.querySelector(".smooth-scroll").style.transform ? "transform" : "fixed"
        });
        ScrollTrigger.addEventListener("refresh", () => locoScroll.update());

        // after everything is set up, refresh() ScrollTrigger and update LocomotiveScroll because padding may have been added for pinning, etc.
        ScrollTrigger.refresh();
        gsap.to("header", {
            scrollTrigger: {
              trigger: "header",
              scroller: ".smooth-scroll",
              // scrub: 1,
              pin: true,
              start: "0% top",
              endTrigger: ".end",
              end: "bottom bottom",
            //   markers: true
            },

            ease: "power2.out"
          });
  
        // this.timelinegsap
            var board = document.getElementById("board")
            $('#downbtn').on('click', function() {
                locoScroll.scrollTo(board.getBoundingClientRect().top - 100)
            });
                
        

})

}